import { RumInitConfiguration, datadogRum } from '@datadog/browser-rum';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';

declare global {
    // var must be used.
    // eslint-disable-next-line no-var
    var MAC_DD_RUM: RumInitConfiguration | undefined;
    // eslint-disable-next-line no-var
    var DD_RUM: typeof datadogRum | undefined;
}

/**
 * Initializes the global datadog instance. This should only be done once, and shouldn't be directly consumed
 * by code for experiences.
 */
export const initDatadog = () => {
    if (!globalThis.MAC_DD_RUM) {
        const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
        datadogRum.init(publicRuntimeConfig.datadog);
        globalThis.MAC_DD_RUM = publicRuntimeConfig.datadog;
    }
    datadogRum.startSessionReplayRecording();
    return datadogRum;
};
